import generateProfileLink from 'src/services/user_profile_link_generator/user_profile_link_generator'
import { library } from '@fortawesome/fontawesome-svg-core'
import neetImage from '../../assets/neet.png'
import neetUnreadImage from '../../assets/neet-unread.png'
import neetNomessagesImage from '../../assets/neet-nomessages.png'
import {
  faBullhorn,
  faTimes
} from '@fortawesome/free-solid-svg-icons'
import { useShoutStore } from 'src/stores/shout'

library.add(
  faBullhorn,
  faTimes
)

const shoutPanel = {
  props: ['floating', 'hide-neet'],
  data () {
    return {
      currentMessage: '',
      last: null,
      channel: null,
      collapsed: true
    }
  },
  computed: {
    messages () {
      return useShoutStore().messages
    },
    unread () {
      return useShoutStore().messages.length > 0 &&
        this.last !== useShoutStore().messages[useShoutStore().messages.length - 1].id
    },
    neetImage () {
      if (this.unread) {
        return neetUnreadImage;
      }

      return useShoutStore().messages.length > 0 ? neetImage : neetNomessagesImage
    }
  },
  methods: {
    submit (message) {
      useShoutStore().channel.push('new_msg', { text: message }, 10000)
      this.currentMessage = ''
    },
    togglePanel () {
      this.collapsed = !this.collapsed
      this.updateLast()
    },
    updateLast () {
      if (useShoutStore().messages && useShoutStore().messages.length) {
        this.last = useShoutStore().messages[useShoutStore().messages.length - 1].id
      }
    },
    userProfileLink (user) {
      return generateProfileLink(user.id, user.username, this.$store.state.instance.restrictedNicknames)
    }
  },
  watch: {
    messages () {
      const scrollEl = this.$el.querySelector('.chat-window')
      if (!scrollEl) {
        if (this.last == null) {
          this.updateLast()
        }

        return
      }

      if (scrollEl.scrollTop + scrollEl.offsetHeight + 20 > scrollEl.scrollHeight) {
        this.$nextTick(() => {
          if (!scrollEl) return

          scrollEl.scrollTop = scrollEl.scrollHeight - scrollEl.offsetHeight
        })
      }

      this.updateLast()
    }
  }
}

export default shoutPanel
